<template>
  <UpdaterLoader v-if="fetcher"/>
  <FilterForm
    v-if="selectedOption != null && !isSmallWindow && currentHook.form != null"
    :key="selectedOption"
    @submitForm="submitForm"
    @input-change="inputWasChangedOnForm"
    :selectedOption="selectedOption"
    :currentweek="currentweek"
    :form="currentHook.form" />
  <template v-if="selectedOption != null && isSmallWindow">
    <div class="backnav">
      <BackNavigation 
        class="backnavbutton"
        :text="$t('back')"
        @click="$emit('goback')" /> 
      <div class="psqbtn" 
        :class="{'disabled': !canSearch}"
        @click="submitMobileForm">
        {{$t('pesquisarword')}}
      </div>  
    </div> 
    <FilterPropertyForm 
      :key="selectedOption"
      @input-change="inputWasChangedOnForm"
      :selectedOption="selectedOption"
      :currentweek="currentweek"
      :form="currentHook.form" /> 
  </template>  
</template>

<script>
import { ref, watch, computed, onMounted, onBeforeUpdate, onBeforeMount } from 'vue';
import useScreenSize from '@/hooks/useScreenSize.js';
import FilterForm from '@/containers/desktop/FilterForm.vue';
import FilterPropertyForm from '@/containers/mobile/FilterPropertyForm.vue';
import { getFormHook } from '@/hooks/FormFactory.js';
import useFormValidation from '@/hooks/formValidation.js';
import UpdaterLoader from '@/components/updaterLoader.vue';
import { i18n } from '@/main.js';
import BackNavigation from '@/components/backnavigation.vue';
import { useEventSearch } from "@/stores/eventSearch.ts";


const LOADER_SHOW_DELAY = 150;


export default {
  name: "Forms",
  props:["selectedOption","openFilter"],
  emits:["submitFormData","goback"],
  components:{
    FilterForm,
    FilterPropertyForm,
    UpdaterLoader,
    BackNavigation
  },
  setup(props){

    const eventsearch = useEventSearch();
    const currentweek = computed(()=> eventsearch.selectedWeek);
    function updateSelectedWeek(selectedWeek){
      eventsearch.setSelectedWeek(selectedWeek);
    }

    const { width } = useScreenSize();
    const currentFilters = computed(()=>eventsearch.currentFilters);
    const searchedFilter = computed(()=> eventsearch.searchedFilter);
    
    const isSmallWindow = computed(() => width.value < 767);
    const locale = computed(() => i18n.global.locale); 
    
    const selectedOptionIsCurrentSearchOption = () => searchedFilter?.value?.id == props.selectedOption.id;

    const getFiltersForSelectedOption = () => {
      return selectedOptionIsCurrentSearchOption() ? 
        currentFilters.value : 
        null;
    }

    let currentHook = ref(null);
    let updatingFilter = ref(false)

    const updateOptionsForForm = (locale) => {
      const timer = setTimeout(() => {
        updatingFilter.value = true;
      },LOADER_SHOW_DELAY);
      currentHook.value.fetchOptions(currentweek.value,locale).
        then(()=> {
          updatingFilter.value = false;
          currentHook.value.checkFormAfterChanginDate();
          clearTimeout(timer);
        });
    }

    watch(()=>props.openFilter, isOpen => {
      if(isOpen && selectedOptionIsCurrentSearchOption()){
        for(const key in currentFilters.value){
          if(currentHook.value.form[key]){
            currentHook.value.form[key].value = currentFilters.value[key];
          }
        }
      }
    },{ immediate: true });

    

    watch(() => props.selectedOption.id, (newVal) => {
      currentHook.value = getFormHook(newVal)(isSmallWindow.value, getFiltersForSelectedOption());
      currentHook.value.setFormDate(currentweek.value);
      updateOptionsForForm(locale.value)
    }, { immediate: true });

    watch(() => currentweek.value.start, () => {
      currentHook.value.setFormDate(currentweek.value);
      updateOptionsForForm(locale.value)
    }, { immediate: false });
    

    watch(locale, newLocale => {
      updateOptionsForForm(newLocale)
    }, { immediate: false });

    const uns = eventsearch.$onAction(({ name, args }) => {
      if (name === 'removeFilterValue') {
        const propertyName = args[0];
        currentHook.value.form[propertyName].value = null;
      }
    }, false);

    const canSearch = computed(() => {
      return Object.values(currentHook.value.form).every(field => 
        !field.required || (field.required && field.value != null)
      );
    })

    const trysubmit = ref(false)
    
    return {
      isSmallWindow,
      currentHook: currentHook,
      fetcher: computed(() => updatingFilter.value),
      canSearch,
      currentweek,
      updateSelectedWeek,
      trysubmit
    }
  },
  methods: {
    submitMobileForm(){
      if(this.isFormValid()){
        const [selectedDates,params,form] = this.currentHook.getSubmitData(null,this.currentweek);
        this.$emit("submitFormData",[selectedDates,params,form]);
      }
    },
    submitForm(dates){
      this.trysubmit = true;
      if(this.isFormValid()){
        const [selectedDates,params,form] = this.currentHook.getSubmitData(dates,this.currentweek);
        this.$emit("submitFormData",[selectedDates,params,form]);
        this.trysubmit = false;
      }
    },
    isFormValid(){
      const { validateForm } = useFormValidation();
      return validateForm(this.currentHook.form);
    },
    inputWasChangedOnForm(value,key){
      if(this.trysubmit){
        if(key == "date"){
          this.updateSelectedWeek(value);
        }
        const { validateField } = useFormValidation();
        validateField(this.currentHook.form,value,key);
      }      
    },
  },
};
</script>


<style>
.backnav{
    background-color: #292a2b;
    padding: 10px 15px;
    position: fixed;
    right: 0;
    left: 0;
    z-index: 5;
    top: 0;
    display: flex;
    justify-content: space-between;
  }

  .psqbtn{
    color: white;
    font-family: "Montserrat";
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .psqbtn.disabled{
    color: #cacaca;
  }

  .backnavbutton{
    padding-top: 5px;
    padding-bottom: 5px;;
  }
</style>